module.exports = __webpack_public_path__ + "static/media/news2.566172fc.png";